import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: ':hash',
    loadChildren: () =>
      import('@pages/main-wrapper/main-wrapper.routing').then(
        (m) => m.MainWrapperRouting
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('@pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  }
];
